import type { Reducer } from 'redux';
import { ADD_ITEM, REMOVE_ITEM, type ItemsAction } from '../actions';

export type ItemsState = Record<string, any>;

const initialState: ItemsState = {};

const reducer: Reducer<ItemsState, ItemsAction> = (state = initialState, action) => {
  let data: any;
  let newState: ItemsState;

  switch (action.type) {
    case ADD_ITEM:
      if (action.data && (action.data as any).constructor === Function) {
        data = (action.data as any)(state[action.name]);
      } else {
        data = action.data;
      }
      return { ...state, [action.name]: data };
    case REMOVE_ITEM:
      newState = { ...state };
      delete newState[action.name];
      return newState;
    default:
      return state;
  }
};

export default reducer;
